import MenuItem from "@mui/material/MenuItem/MenuItem";
import React from "react";
import { SelectInput, SelectInputProps } from '@coverright/ui/inputs';
import { colorByStatus, darkenHexColor, FilterProps, labelByStatus } from '../shared';
import { Typography } from '@mui/material';
import { Status, StatusDto } from '@coverright/data-access/types/enrollment';

type Props = Omit<SelectInputProps, 'onChange' | 'value'> & FilterProps<StatusDto | ''> & {
  statuses?: StatusDto[];
}

const StatusFilter = ({value, onChange, statuses, ...rest}: Props) => (
  <SelectInput hideTick
               {...rest}
               value={value}
               onChange={event => {
                 onChange(event.target.value as StatusDto)
               }}
               renderValue={selected => {
                 if (!selected) {
                   return rest.label ? '-' : 'Status';
                 }
                 return <StatusView status={selected as StatusDto} />
               }}
  >
    <MenuItem value={''}>-</MenuItem>
    {(statuses || statusList).map((item) => (
      <MenuItem value={item} key={item}> <StatusView status={item} /></MenuItem>
    ))}
  </SelectInput>
)

export default StatusFilter;

export const StatusView = ({status}: {status?: StatusDto | Status}) => (
  <Typography sx={{color: darkenHexColor(colorByStatus(status), 50), fontSize: 14, fontWeight: 500}}>
    {labelByStatus(status)}
  </Typography>
)

const statusList = [
  StatusDto.NotYetEngaged,
  StatusDto.Attempted,
  StatusDto.Contacted,
  StatusDto.FollowUp,
  StatusDto.SalesQualified,
  StatusDto.ApplicationSubmitted,
  StatusDto.Disenrolled,
  StatusDto.Disqualified,
  StatusDto.Test,
  StatusDto.Duplicated,
  StatusDto.OutOfService,
]


